<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="400px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.name')" 
                                        v-model="data.name"
                                        :rules="rules.name" 
                                        @change="data.name=formSpaces(data.name)"
                                        dense
                                        required
                                        outlined
                                    ></v-text-field>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.identCode')" 
                                        v-model="data.gwid"
                                        :rules="rules.gwid" 
                                        @change="data.gwid=formSpaces(data.gwid)"
                                        dense
                                        required
                                        outlined
                                    ></v-text-field>
                                    <v-select
                                        v-if="role === 0"
                                        :items="group"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.groupName')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.groupID"
                                        :rules="rules.groupID" 
                                        @change="changeGroup"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        v-if="role !== 2"
                                        :items="shop"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.shopName')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.shopID"
                                        :rules="rules.shopID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="scheduler"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.scheduler')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.scheduleID"
                                        :rules="rules.scheduleID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="smsNet"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.smsNet')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.smsgatewayID"
                                        :rules="rules.smsgatewayID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="userAc"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.userAc')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.usercheckID"
                                        :rules="rules.usercheckID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="macAc"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.macAc')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.maccheckID"
                                        dense
                                        outlined
                                        clearable
                                    ></v-select>
                                    <v-select
                                        :items="phoneAllowList"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.phoneAllowList')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.phoneAllowListId"
                                        dense
                                        outlined
                                        clearable
                                    ></v-select>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose">
                            {{$vuetify.lang.t('$vuetify.portalManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleSave" :loading="loading">
                            {{$vuetify.lang.t('$vuetify.portalManage.save')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    props: {
        role : Number,
        group: Array
    },

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.portalManage.ac.insertBtn'),

            loading: false,

            dialog: false,

            shop: [],
            scheduler: [],
            smsNet: [],
            userAc: [],
            macAc: [],
            phoneAllowList: [],

            data: {
                name: null,
                gwid: null,
                groupID: null,
                shopID: null,
                scheduleID: null, 
                smsgatewayID: null,
                usercheckID: null,
                maccheckID: null,
                phoneAllowListId: null
            },

            rules: {
                name: [
                    value => this.formSpaces(value)!='' || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.name'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.name')
                ],
                gwid: [
                    value => this.formSpaces(value)!='' || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.identCode'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.identCode')
                ],
                groupID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.groupName')
                ],
                shopID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.shopName')
                ],
                scheduleID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.scheduler')
                ],
                smsgatewayID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.smsNet')
                ],
                usercheckID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.userAc')
                ]
            }
            
        }
    },

    methods: {

        formSpaces(str){
            if(str !== null && str !== undefined){
                let res = str.replace(/\s*/g,'')
                return res;
            }
        },

        handleOpen () {
            this.data.groupID = this.group[0].id === undefined ? null : this.group[0].id;
            this.changeGroup(this.data.groupID);
            this.dialog = true;
        },

        handleReset () {
            this.data = {
                name: null,
                gwid: null,
                groupID: null,
                shopID: null,
                scheduleID: null, 
                smsgatewayID: null,
                usercheckID: null,
                maccheckID: null
            };
            this.$refs.form.resetValidation();
        },

        handleClose () {
            this.dialog = false;
            this.handleReset();
        },

        handleSave () {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.data.shopID = this.data.shopID === 0 ? null : this.data.shopID;
                this.$http.post(api.default.portal.acAddUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        },

        changeGroup (value) {
            this.getShop(value);
            this.getScheduler(value);
            this.getSmsGateway(value);
            this.getRadcheck(value);
        }, 

        getShop (value) {
            this.$http.post(api.default.rbac.shopListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.shop = resp.data.list;
                this.shop.splice(0, 0, {
                    id: 0,
                    name: '所有场所'
                })
                this.data.shopID = 0;
            })
        },

        getScheduler(value){
            this.$http.post(api.default.portal.scheduleListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.scheduler = resp.data.list;
                this.data.scheduleID = this.scheduler[0].id;
            })
        },

        getSmsGateway (value) {
            this.$http.post(api.default.portal.gatewayListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.smsNet = resp.data;
                this.data.smsgatewayID = this.smsNet[0].id;
            })
        },

        getRadcheck (value) {
            this.$http.post(api.default.portal.radcheckListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.userAc = resp.data.list;
                this.data.usercheckID = this.userAc[0].id;
                this.macAc = resp.data.list;
                this.phoneAllowList = resp.data.list;
            })
        }

    }
}
</script>